/** iMessage cards: three on phones, all on larger screens; all remain readable without JS. */
export function clientMessages() {
  document.querySelectorAll('[data-client-messages]').forEach((section) => {
    if (section.dataset.messagesReady) return;
    const cards = [...section.querySelectorAll('[data-message-thread]')];
    const button = section.querySelector('[data-messages-toggle]');
    const extra = cards.slice(3);
    if (!button || !extra.length) return;

    const mobile = window.matchMedia('(max-width: 767px)');
    let expanded = false;
    const update = () => {
      const showAll = !mobile.matches || expanded;
      extra.forEach((card) => { card.hidden = !showAll; });
      button.hidden = !mobile.matches;
      button.setAttribute('aria-expanded', String(showAll));
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
    };

    button.addEventListener('click', () => {
      expanded = !expanded;
      update();
      // Keep the control in view after the content above it collapses.
      if (!expanded) button.scrollIntoView({ block: 'nearest', behavior: 'instant' });
    });
    mobile.addEventListener('change', () => {
      if (mobile.matches && !expanded && extra.some((card) => card.contains(document.activeElement))) {
        button.hidden = false;
        button.focus({ preventScroll: true });
      }
      update();
    });
    section.dataset.messagesReady = 'true';
    update();
  });
}
